module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "serial-form"
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/modul-pembelajaran-old'
      }
    }
  }, [_vm._v("Modul Pembelajaran")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Buat Modul Pembelajaran Baru")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((_vm.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v("\n                                " + _vm._s(message) + "\n                            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal form-bordered",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama Modul *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nama Modul Pembelajaran",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Mata Pelajaran *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.subject),
      expression: "form.subject"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "subject", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("\n                                        Pilih Mapel\n                                    ")]), _vm._v(" "), _vm._l((_vm.mapelList), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v("\n                                        " + _vm._s(item.nama) + "\n                                    ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.level),
      expression: "form.level"
    }],
    attrs: {
      "type": "radio",
      "name": "optradio",
      "value": "SD",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.form.level, "SD")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.form, "level", "SD")
      }, function($event) {
        _vm.form.grades = []
      }]
    }
  }), _vm._v("SD")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.level),
      expression: "form.level"
    }],
    attrs: {
      "type": "radio",
      "name": "optradio",
      "value": "SMP"
    },
    domProps: {
      "checked": _vm._q(_vm.form.level, "SMP")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.form, "level", "SMP")
      }, function($event) {
        _vm.form.grades = []
      }]
    }
  }), _vm._v("SMP")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.level),
      expression: "form.level"
    }],
    attrs: {
      "type": "radio",
      "name": "optradio",
      "value": "SMA"
    },
    domProps: {
      "checked": _vm._q(_vm.form.level, "SMA")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.form, "level", "SMA")
      }, function($event) {
        _vm.form.grades = []
      }]
    }
  }), _vm._v("SMA")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [(_vm.form.level === 'SD') ? _c('v-row', [_c('span', {
    staticClass: "ml-5 mr-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.grades),
      expression: "form.grades"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.grades) ? _vm._i(_vm.form.grades, "1") > -1 : (_vm.form.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "grades", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "grades", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "grades", $$c)
        }
      }
    }
  }), _vm._v("\n                                         1\n                                    ")]), _vm._v(" "), _c('span', {
    staticClass: "mr-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.grades),
      expression: "form.grades"
    }],
    attrs: {
      "type": "checkbox",
      "value": "2"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.grades) ? _vm._i(_vm.form.grades, "2") > -1 : (_vm.form.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "grades", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "grades", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "grades", $$c)
        }
      }
    }
  }), _vm._v("\n                                         2\n                                    ")]), _vm._v(" "), _c('span', {
    staticClass: "mr-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.grades),
      expression: "form.grades"
    }],
    attrs: {
      "type": "checkbox",
      "value": "3"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.grades) ? _vm._i(_vm.form.grades, "3") > -1 : (_vm.form.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "3",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "grades", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "grades", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "grades", $$c)
        }
      }
    }
  }), _vm._v("\n                                         3\n                                    ")]), _vm._v(" "), _c('span', {
    staticClass: "mr-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.grades),
      expression: "form.grades"
    }],
    attrs: {
      "type": "checkbox",
      "value": "4"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.grades) ? _vm._i(_vm.form.grades, "4") > -1 : (_vm.form.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "4",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "grades", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "grades", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "grades", $$c)
        }
      }
    }
  }), _vm._v("\n                                         4\n                                    ")]), _vm._v(" "), _c('span', {
    staticClass: "mr-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.grades),
      expression: "form.grades"
    }],
    attrs: {
      "type": "checkbox",
      "value": "5"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.grades) ? _vm._i(_vm.form.grades, "5") > -1 : (_vm.form.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "5",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "grades", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "grades", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "grades", $$c)
        }
      }
    }
  }), _vm._v("\n                                         5\n                                    ")]), _vm._v(" "), _c('span', {
    staticClass: "mr-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.grades),
      expression: "form.grades"
    }],
    attrs: {
      "type": "checkbox",
      "value": "6"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.grades) ? _vm._i(_vm.form.grades, "6") > -1 : (_vm.form.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "6",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "grades", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "grades", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "grades", $$c)
        }
      }
    }
  }), _vm._v("\n                                         6\n                                    ")])]) : _vm._e(), _vm._v(" "), (_vm.form.level === 'SMP') ? _c('v-row', [_c('span', {
    staticClass: "ml-5 mr-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.grades),
      expression: "form.grades"
    }],
    attrs: {
      "type": "checkbox",
      "value": "7"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.grades) ? _vm._i(_vm.form.grades, "7") > -1 : (_vm.form.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "7",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "grades", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "grades", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "grades", $$c)
        }
      }
    }
  }), _vm._v("\n                                         7\n                                    ")]), _vm._v(" "), _c('span', {
    staticClass: "mr-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.grades),
      expression: "form.grades"
    }],
    attrs: {
      "type": "checkbox",
      "value": "8"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.grades) ? _vm._i(_vm.form.grades, "8") > -1 : (_vm.form.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "8",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "grades", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "grades", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "grades", $$c)
        }
      }
    }
  }), _vm._v("\n                                         8\n                                    ")]), _vm._v(" "), _c('span', {
    staticClass: "mr-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.grades),
      expression: "form.grades"
    }],
    attrs: {
      "type": "checkbox",
      "value": "9"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.grades) ? _vm._i(_vm.form.grades, "9") > -1 : (_vm.form.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "9",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "grades", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "grades", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "grades", $$c)
        }
      }
    }
  }), _vm._v("\n                                         9\n                                    ")])]) : _vm._e(), _vm._v(" "), (_vm.form.level === 'SMA') ? _c('v-row', [_c('span', {
    staticClass: "ml-5 mr-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.grades),
      expression: "form.grades"
    }],
    attrs: {
      "type": "checkbox",
      "value": "10"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.grades) ? _vm._i(_vm.form.grades, "10") > -1 : (_vm.form.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "10",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "grades", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "grades", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "grades", $$c)
        }
      }
    }
  }), _vm._v("\n                                         10\n                                    ")]), _vm._v(" "), _c('span', {
    staticClass: "mr-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.grades),
      expression: "form.grades"
    }],
    attrs: {
      "type": "checkbox",
      "value": "11"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.grades) ? _vm._i(_vm.form.grades, "11") > -1 : (_vm.form.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "11",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "grades", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "grades", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "grades", $$c)
        }
      }
    }
  }), _vm._v("  11\n                                    ")]), _vm._v(" "), _c('span', {
    staticClass: "mr-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.grades),
      expression: "form.grades"
    }],
    attrs: {
      "type": "checkbox",
      "value": "12"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.grades) ? _vm._i(_vm.form.grades, "12") > -1 : (_vm.form.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "12",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "grades", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "grades", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "grades", $$c)
        }
      }
    }
  }), _vm._v("\n                                         12\n                                    ")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Semester")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.semester),
      expression: "form.semester"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "semester", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("\n                                            Pilih Semester\n                                        ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GANJIL"
    }
  }, [_vm._v("\n                                            GANJIL\n                                        ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GENAP"
    }
  }, [_vm._v("GENAP")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Upload PDF *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-6"
  }, [_c('div', {
    staticClass: "row ml-2"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('v-btn', {
    staticClass: "black60--text mb-4",
    attrs: {
      "width": "154px",
      "height": "76px",
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.uploader.click()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "30"
    }
  }, [_vm._v("mdi-cloud-upload")]), _vm._v(" "), _c('p', [_vm._v("Upload File")])], 1)]), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), (_vm.$route.query.id) ? _c('div', {
    staticClass: "column ml-5"
  }, [_c('label', [_vm._v(_vm._s(_vm.fileName))])]) : _vm._e(), _vm._v(" "), (!_vm.$route.query.id) ? _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v(_vm._s(_vm.fileName2))])]) : _vm._e()])])]), _vm._v(" "), (_vm.form.url) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("View PDF")]), _vm._v(" "), _c('div', {
    staticClass: "pdf-container"
  }, [_c('embed', {
    attrs: {
      "src": _vm.form.url,
      "type": "application/pdf",
      "width": "100%",
      "height": "100%"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Password PDF")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Password PDF"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tidak Dimunculkan")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [_c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    attrs: {
      "type": "checkbox",
      "name": "TidakDimunculkan"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.status) ? _vm._i(_vm.form.status, null) > -1 : (_vm.form.status)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.status,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "status", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "status", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "status", $$c)
        }
      }
    }
  }), _vm._v("\n                                          Tidak Dimunculkan\n                                    ")])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1)])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Buat Modul Pembelajaran")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                                Simpan\n                            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80df259e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/modul_belajar_old/components/Form.vue
// module id = 1901
// module chunks = 1